import * as React from 'react';
import {StatelessComponent} from 'react';

import './styles.sass';

export interface IAuthContentProps {
  children?: any;
}

export const AuthContent: StatelessComponent<IAuthContentProps> = ({
  children,
}: IAuthContentProps) => (
  <div className={'auth-content'}>
    {children}
  </div>
);
